module.exports = __webpack_public_path__ + "img/pg-bg.f040c1fa.png";